import type {TaskInstance, TaskWithInstance} from '@backend/types'

function getTodayStr(): string {
  const d = new Date()
  return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0')
}

export function isAgendaInstance(instance: TaskInstance): boolean {
  if (instance.done) return false
  if (!instance.due_date) return false
  return String(instance.due_date).slice(0, 10) <= getTodayStr()
}

export function isAgendaTask(task: TaskWithInstance): boolean {
  return task.instances.some((i) => isAgendaInstance(i))
}
